module.exports = __webpack_public_path__ + "img/avartar.a6346d1e.png";